export const fullscreenClasses = 'flex flex-col h-[calc(100vh-3.5rem)] overflow-hidden';

export const headerClasses =
    'flex items-center justify-between gap-4 py-5 px-10 border-b border-b-border ' +
    'shrink-0 bg-white shadow-header';

export const headerLeftClasses = 'flex flex-1 items-center gap-4 min-w-0';

export const headerTitleClasses =
    'text-subsection-title text-content font-serif ' +
    'm-0! max-w-[40vw] whitespace-nowrap overflow-hidden text-ellipsis';

export const headerCloseClasses =
    'flex items-center gap-2 font-secondary font-semibold text-base ' +
    'text-content cursor-pointer hover:text-primary';

export const bodyClasses = 'flex-1 overflow-y-auto p-6 bg-surface-card min-h-0';

export const bodyInnerClasses = 'mx-auto w-full max-w-6xl flex flex-col gap-6';

export const pairGridClasses = 'grid grid-cols-1 lg:grid-cols-2 gap-6';

export const optionCardClasses =
    'bg-surface border border-border rounded-2xl p-8 shadow-sm flex flex-col items-center text-center h-full';

export const disclaimerClasses =
    'text-xs leading-relaxed text-subtle border-t border-border pt-4 px-1';
